import { Injectable } from '@angular/core';
import { SchedulerBaseItem } from '../models/item';
import { orderByRank } from '../../drag-drop/utils/order-by-rank';
import { SchedulerDragDropAbstract } from './drag-drop';
import { DragAndDropEvent } from '../../drag-drop/types/event';
import { dragAndDropChangeRank } from '../../drag-drop/utils/modify-rank';

@Injectable()
export class SchedulerListDragDropService<
  Type extends SchedulerBaseItem
> extends SchedulerDragDropAbstract<Type> {
  protected async success(event: DragAndDropEvent<Type>): Promise<Type[]> {
    return this.newVersionsOfLists(event, (val) => {
      return orderByRank(val);
    });
  }

  protected async saveChanges(event: DragAndDropEvent<Type>): Promise<void> {
    const itemToMove = event.item.data;
    // const isOnList = this.containerService.getList(event.container.id);
    const rank = this.createNewRank(event);
    if (rank) {
      await this.apiRouter.updateRank(itemToMove.id, rank).toPromise();
      itemToMove.rank = rank;
    }
    await this.removingItemOfMachine(event);
    // we change the rank of item that was moved.
    // itemToMove.itemsOnMachine = [];
  }

  /**
   * This method will remove the item from a machine in the case it's coming from a machine;
   * @param event
   * @protected
   */
  protected async removingItemOfMachine(
    event: DragAndDropEvent<Type>
  ): Promise<any> {
    if (!event.previousContainer.id.includes('machine')) {
      return;
    }
    const itemToMove = event.item.data;
    const containerId = event.previousContainer.id.split('-');
    const machineId = parseInt(containerId[containerId.length - 1], 10);

    return await this.apiRouter
      .removeItem(itemToMove.id, machineId)
      .toPromise();
  }

  protected createNewRank(event: DragAndDropEvent<Type>): string {
    if (!this.allowedToBeOrdered || !this.authService.orderingItems()) {
      return null;
    }
    const list = [...event.container.data, event.item.data];
    return dragAndDropChangeRank(
      list,
      event.currentIndex,
      event.container.id !== event.previousContainer.id
        ? list.length - 1
        : event.previousIndex
    );
  }
}
